import { makeStyles } from '@material-ui/core/styles';

export default makeStyles((theme) => ({
  root: {
    display: 'contents',
    width: '100%',
  },
  header: {
    marginBottom:'3em',
  },
  input: {
    display: "none",
  },
  leftTextfields: {
    width: "90%",
    marginTop: "10px",
    minWidth: "10vw",
    maxWidth: "550px",
  },
  rightTextfields: {
    width: "85%",
    marginTop: "10px",
    minWidth: "10vw",
  },
  subtitles: {
    color: theme.palette.primary.main,
    fontSize: 16,
    fontWeight: 400,
    marginTop: theme.spacing(2),
  },
  controlButton: {
    marginRight: theme.spacing(1),
    fontSize: 16,
    fontWeight: 300,
    textDecoration: 'underline',
    '&:hover': {
      textDecoration: 'underline',
    },
  },
  infoText:{
    alignItems:'center',
    marginTop:'1em',
    marginBottom:'2em',
    marginLeft: theme.spacing(4)
  }
}));
